<script>
  import { goto } from "$app/navigation";
  import { onMount } from "svelte";
  
  // Redirect to the main services page
  onMount(() => {
    goto('/services');
  });
</script>

<div class="container mx-auto py-16 px-4">
  <h1 class="text-3xl font-bold mb-6">Development Services</h1>
  <p class="mb-4">Redirecting to services page...</p>
</div>
